module.exports = __webpack_public_path__ + "img/bid_agent-2.7e6b4966.png";